<template>
  <div></div>
</template>

<script>
export default {
  methods: {
    async tokenLogin() {
      await this.$store.dispatch('tokenLogin', {
        token: this.$route.params.token,
      });
    },
  },
  mounted() {
    this.tokenLogin();
  },
};
</script>
